import {IElementLikertScale} from '../question/likertScale';
import {ELEMENT} from '../base/ElementTypes';
import {IElementMultiSelect} from '../question/multiSelect';
import {IElementSequenceQuestion} from '../question/questionSequence';
import {IElementQuestion} from '../question/question';
import {IQuestionReportElement} from '../question/questionReportElement';

export type HtmlSlottedElement = (
    | IElementQuestion
    | IElementMultiSelect
    | IElementSequenceQuestion
    | IElementLikertScale
    | IQuestionReportElement
) & {htmlSlotId: string};

const HTML_SLOTTED_TYPES: string[] = [
    ELEMENT.QUESTION,
    ELEMENT.MULTI_SELECT,
    ELEMENT.SEQUENCE_QUESTION,
    ELEMENT.LIKERT_SCALE,
    ELEMENT.QUESTION_REPORT,
];

export function isHtmlSlottedElement(element: {type: string; htmlSlotId?: string}): element is HtmlSlottedElement {
    return HTML_SLOTTED_TYPES.includes(element.type) && Boolean(element.htmlSlotId);
}

export function isHtmlQuestionReportElement(element: {
    type: string;
    htmlSlotId?: string;
}): element is IQuestionReportElement & {htmlSlotId: string} {
    return element.type === ELEMENT.QUESTION_REPORT && Boolean(element.htmlSlotId);
}
